<template>
  <div class="ol-opportunity-contact-panel">
    <!-- Teléfono(s) -->
    <!-- <div v-if="hasPhonesSection" class="ol-phones-card">
      <h6 class="section-title-inline">
        <i class="icon-phone"></i>
        {{ $t("lang.opportunities.left_panel_phones") }}
      </h6>

      <Phone
        v-for="phone in getPhone()"
        v-bind:key="'phone' + phone"
        :phone="phone"
        :link_id="link.id"
        icon="icon-building"
      />

      <template v-for="contact in businessContacts">
        <Phone
          v-if="contact.phone && !$route.fullPath.includes('/opportunities/')"
          :key="'phone-contact-' + contact.id"
          :phone="contact.phone"
          :name="contact.name"
          :link_id="link.id"
          :source_phone="contact.source_phone ? contact.source_phone : 'Apollo'"
          :phone_updated="contact.phone_updated ? contact.phone_updated.substring(0, 10) : null"
          icon="icon-user"
          @removePhoneContact="removePhoneContact(contact)"
        />
      </template>

      <template v-for="contact in businessContacts">
        <Phone
          v-if="contact.event_phone"
          :key="'contact-event-' + contact.id"
          :phone="contact.event_phone"
          :name="contact.name"
          :link_id="link.id"
          icon="icon-calendar"
        />
      </template>
    </div> -->

    <!-- Contactos -->
    <div v-if="businessContacts.length > 0" class="ol-contacts-panel-list">
      <div class="section-title-inline">
        <i class="icon-users"></i>
        {{ $t("lang.label.contacts") }}
        <span class="contacts-count-badge">{{ businessContacts.length }}</span>
      </div>

      <div
        v-for="contact in businessContacts"
        :key="contact.id"
        class="contact-card"
      >
        <div class="contact-header">
          <div
            class="contact-avatar"
            :class="{ 'contact-avatar--inactive': contact.active != 1 }"
          >
            <img
              v-if="hasContactPhoto(contact)"
              :src="contact.photo"
              alt=""
              class="contact-avatar-img"
              :class="{ imageblur: contact.valid === 1 }"
            />
            <span v-else class="contact-avatar-initials">{{
              getContactInitials(contact)
            }}</span>
          </div>
          <div class="contact-name-block">
            <div class="contact-name-row">
              <span class="contact-name">
                {{ contact.name | formatContactName(contact.email) }}
              </span>
              <a
                v-if="contact.linkedinurl"
                class="contact-linkedin"
                :href="contact.linkedinurl"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="icon-linkedin color-ln"></i>
              </a>
            </div>
            <div v-if="isContactManager(contact)" class="contact-role">
              {{ replaceChain(contact.job) }}
            </div>
          </div>
          <span
            v-if="contact.active == 1"
            class="contact-status-pill contact-status-pill--active"
          >
            <i class="icon-check-circle"></i>
            <small>{{ $t("lang.label.active") }}</small>
          </span>
          <span v-else class="contact-status-pill contact-status-pill--inactive">
            <i class="icon-minus-circle"></i>
            <small>{{ $t("lang.label.inactive") }}</small>
          </span>
        </div>

        <div
          v-if="contact.business_contact_status_id == 7"
          class="badge badge-danger d-inline mb-2"
        >
          {{ $t("lang.button.donotcontact") }}
        </div>

        <div class="contact-details">
          <div v-if="contact.email" class="contact-detail-row">
            <i class="icon-envelope"></i>
            <small class="font-weight-bold text-primary text-truncate">{{ contact.email }}</small>
            <button type="button" class="copy-inline" @click="copyClipboard(contact.email)">
              <i class="icon-copy"></i>
            </button>
          </div>

          <div v-if="contact.phone" class="contact-detail-row contact-detail-row--phone">
            <Phone
              :phone="contact.phone"
              :link_id="link.id"
              :source_phone="contact.source_phone ? contact.source_phone : 'Apollo'"
              :phone_updated="contact.phone_updated ? contact.phone_updated.substring(0, 10) : null"
              icon="icon-phone"
              deletable
              @removePhoneContact="removePhoneContact(contact)"
            />
          </div>

          <Phone
            v-if="contact.event_phone"
            :phone="contact.event_phone"
            icon="icon-calendar"
          />

          <div v-else-if="permissionFront()" class="contact-detail-row contact-detail-row--input">
            <div class="flex-grow-1 min-width-0">
              <InputPhoneWithCode :contact="contact" @savePhoneContact="savePhoneContact" />
            </div>
          </div>
        </div>

        <div
          v-if="
            permissionFront() &&
            (contact.active == 1 ||
              (contact.active != 1 && contact.business_contact_status_id != 7))
          "
          class="contact-footer"
        >
          <div class="contact-footer-actions">
            <button
              v-if="contact.active == 1"
              type="button"
              class="btn-mini btn-mini--warning"
              @click="unsubscribeContactAction(contact.id, contact.business_contact_status_id)"
            >
              <i class="icon-stop"></i>
              {{ $t("lang.button.unsubscribeall") }}
            </button>
            <button
              v-if="contact.active != 1 && contact.business_contact_status_id != 7"
              type="button"
              class="btn-mini btn-mini--success"
              @click="changeBusinessContactStatusByLinkIdAction(contact.id, contact.business_contact_status_id)"
            >
              <i class="icon-play"></i>
              {{ statusButtonName("donotcontact") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { businessContactsService } from "@/_services";
import { statusButtonMixin, urlMixin, logoMixin } from "@/_mixins";
import { mapState } from "vuex";
import Phone from "@/components/Common/Phone.vue";
import InputPhoneWithCode from "@/components/Common/InputPhoneWithCode.vue";

export default {
  mixins: [statusButtonMixin, urlMixin, logoMixin],
  components: {
    Phone,
    InputPhoneWithCode,
  },
  props: {
    business: Object,
    status: Object,
    businessContacts: {
      type: Array,
      default: () => [],
    },
    link: Object,
    unlocked: String,
  },
  mounted() {
    const contacts = this.businessContacts || [];
    if (contacts.length > 0) {
      const ids = contacts.filter((el) => el.phone == null).map((contact) => contact.id);
      if (ids.length > 0) {
        this.getPhones(ids);
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.authentication.user;
    },
    ...mapState({
      currentUser: (state) => state.authentication.user,
    }),
    isOpportunityRoute() {
      return this.$route.fullPath.includes("/opportunities/");
    },
    hasPhonesSection() {
      if (this.getPhone().length > 0) return true;
      if (this.isOpportunityRoute) {
        return (this.businessContacts || []).some((c) => c.event_phone);
      }
      return (this.businessContacts || []).some((c) => c.phone || c.event_phone);
    },
  },
  methods: {
    hasContactPhoto(contact) {
      if (!contact) {
        return false;
      }
      const photo = contact.photo;
      if (photo == null || photo === "") {
        return false;
      }
      return String(photo).trim().length > 0;
    },
    getContactFullName(contact) {
      if (!contact) {
        return "";
      }
      const fromFields = [contact.first_name, contact.last_name]
        .filter(Boolean)
        .join(" ");
      if (fromFields) {
        return fromFields;
      }
      return contact.name || "";
    },
    getContactInitials(contact) {
      return this.getPersonInitials(this.getContactFullName(contact));
    },
    getPersonInitials(name) {
      if (!name || typeof name !== "string") {
        return "?";
      }
      const trimmed = name.trim();
      if (!trimmed || trimmed.indexOf("@") !== -1) {
        return "?";
      }
      return trimmed
        .split(/\s+/)
        .filter(Boolean)
        .map((word) => word.charAt(0))
        .join("")
        .substring(0, 2)
        .toUpperCase();
    },
    copyClipboard(text) {
      if (window.clipboardData && window.clipboardData.setData) {
        return window.clipboardData.setData("Text", text);
      }
      if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        const textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed";
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand("copy");
        } catch (ex) {
          console.warn("Copy to clipboard failed.", ex);
        } finally {
          document.body.removeChild(textarea);
        }
      }
    },
    replaceChain(chain) {
      if (chain != null) {
        const str = chain.replace(new RegExp("&amp;", "g"), "&");
        return str;
      }
    },
    getPhone() {
      if (this.business && this.business.phone != null && this.business.phone !== "") {
        return String(this.business.phone).split(",");
      }
      return [];
    },
    changeBusinessContactStatusByLinkIdAction(id, statusId) {
      this.$emit("changeBusinessContactStatusByLinkId", {
        businessContactId: id,
        linkId: this.link.id,
        statusId: 7,
      });
    },
    isContactManager(contact) {
      return contact.role != "Generic";
    },
    permissionFront() {
      return (
        this.currentUser.team_role_id == undefined ||
        this.currentUser.team_role_id != 3
      );
    },
    removePhoneContact(contact) {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          businessContactsService.removePhone(contact.id).then(() => {
            contact.phone = "";
          });
        }
      });
    },
    savePhoneContact(value) {
      const contact = this.businessContacts.find((el) => el.id == value.id);
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          businessContactsService.setPhone(value.id, value.newPhone, "Manual").then(() => {
            contact.phone = value.newPhone;
            contact.phone_updated = new Date().toISOString();
            contact.source_phone = "Manual";
          });
        }
      });
    },
    getPhones(ids) {
      businessContactsService
        .getPhones(ids)
        .then((result) => {
          if (result.length > 0) {
            this.businessContacts.forEach((el) => {
              const phone = result.find((item) => item.business_contact_id == el.id);
              if (phone && phone.phone) {
                el.phone = phone.phone;
              }
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    unsubscribeContactAction(id, statusId) {
      this.$emit("unsubscribeContact", {
        businessContactId: id,
        linkId: this.link.id,
        statusId: statusId,
      });
    },
  },
};
</script>

<style scoped>
.color-ln {
  color: #0077b5;
}

.ol-phones-card {
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid #f4f4f7;
}

.section-title-inline {
  font-size: 11px;
  font-weight: 500;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 10px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.contacts-count-badge {
  background: #f4f4f7;
  color: #374151;
  padding: 1px 7px;
  border-radius: 10px;
  font-size: 10px;
  text-transform: none;
  letter-spacing: 0;
}

.contact-card {
  padding: 12px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  margin-bottom: 8px;
}

.contact-card:last-child {
  margin-bottom: 0;
}

.contact-header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 8px;
}

.contact-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #eeeefc;
  flex-shrink: 0;
  overflow: hidden;
}

.contact-avatar--inactive {
  background: #f4f4f7;
}

.contact-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.contact-avatar-initials {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #4b4be1;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
}

.contact-avatar--inactive .contact-avatar-initials {
  background: #9ca3af;
}

.contact-name-block {
  flex: 1;
  min-width: 0;
}

.contact-name-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.contact-name {
  font-size: 13px;
  font-weight: 500;
  color: #111827;
}

.contact-role {
  font-size: 11px;
  color: #6b7280;
}

.contact-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 10px;
  font-weight: 500;
  padding: 2px 7px;
  border-radius: 4px;
  white-space: nowrap;
  flex-shrink: 0;
}

.contact-status-pill--active {
  background: #d1fae5;
  color: #065f46;
}

.contact-status-pill--inactive {
  background: #f4f4f7;
  color: #6b7280;
}

.contact-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.contact-detail-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  min-width: 0;
}

.contact-detail-row > i:first-child {
  color: #9ca3af;
  flex-shrink: 0;
}

.contact-detail-row--phone,
.contact-detail-row--input {
  align-items: flex-start;
}

.copy-inline {
  background: none;
  border: none;
  padding: 2px 4px;
  border-radius: 4px;
  cursor: pointer;
  color: #9ca3af;
  flex-shrink: 0;
  margin-left: auto;
}

.copy-inline:hover {
  background: #f4f4f7;
  color: #374151;
}

.contact-footer {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f4f4f7;
}

.contact-footer-actions {
  display: flex;
  gap: 6px;
  width: 100%;
}

.contact-footer-actions .btn-mini {
  flex: 1;
  justify-content: center;
  min-width: 0;
}

.btn-mini {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: white;
  border: 1px solid #e5e7eb;
  padding: 5px 9px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
}

.btn-mini:hover {
  border-color: #4b4be1;
  color: #4b4be1;
  background: #f7f7fe;
}

.btn-mini--warning:hover {
  border-color: #92400e;
  color: #92400e;
  background: #fef3c7;
}

.btn-mini--success:hover {
  border-color: #065f46;
  color: #065f46;
  background: #d1fae5;
}

.min-width-0 {
  min-width: 0;
}
</style>
